<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1; overflow: hidden">
        <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
            <div class="robotoMedium"
                style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Announcements</span>
            </div>
            <div
                style="color: white; padding: 10px; font-size: 11pt; display: flex; flex-direction: column; justify-content: center; align-items: center; flex: 1;">
                {{currentDate}}
            </div>
            <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; padding: 5px; flex: 1;">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end">
                    <button *ngIf="announcements.length > 0" mat-stroked-button class="mat-card-button"
                        (click)="viewDetailsClick()"><span translate>Go To Announcements</span></button>
                </div>
            </div>
        </div>
        <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; flex: 1">
            <div *ngIf="announcements.length == 0"
                style="display: flex; flex-direction: column; flex: 1;align-items: center;padding: 30px;">
                <span translate>No announcements for current date.</span>
            </div>
            <div *ngIf="announcements.length > 0"
                style="display: flex; flex-direction: column; flex: 1; overflow: hidden">
                <mat-accordion *ngIf="districtAnnouncements.length > 0" style="margin: 0px;">
                    <mat-expansion-panel class="mat-elevation-z0 bottomBorder" [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="robotoMedium" style="font-size: 14pt">
                                <span style="margin-right: 2px;" translate>District</span>
                                ({{districtAnnouncements.length}})
                            </mat-panel-title>
                            <mat-panel-description>
                                <!--No Description-->
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <!--Expand Content-->
                        <div style="margin-bottom: 10px;padding: 0 24px !important;"
                            *ngFor="let da of districtAnnouncements">
                            <div class="robotoMedium" style="font-size: 11pt;">
                                <span class="newBadge robotoMedium" style="font-size: 11pt;"
                                    *ngIf="da.IsNewSinceLastLogin == 1" translate>NEW</span><span
                                *ngIf="da.IsNewSinceLastLogin == 1" class="robotoMedium"
                                style="font-size: 11pt;"> - </span> <span class="robotoMedium"
                                style="font-size: 11pt;"> {{da.StartDate | date: 'MM/dd/yy'}} -  </span> <span
                                class="robotoMedium" style="font-size: 11pt;">{{da.Title}}</span>
                            </div>
                            <div>
                                <tyl-quill-text-only #textArea
                                    class="announcementText"
                                    style="margin-right: 35px; -webkit-box-orient: vertical;"
                                    [padding]="0"
                                    [html]="da.Announcement"
                                    ExternalLink></tyl-quill-text-only>
                                <span *ngIf="da.Overflow"> <a
                                    style="display: flex;justify-content: flex-end;position: relative;top: -18px;"
                                    (click)="moreClick(da)" translate>More</a></span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <mat-accordion *ngIf="schoolAnnouncements.length > 0" style="margin: 0px;">
                    <mat-expansion-panel class="mat-elevation-z0 bottomBorder" [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="robotoMedium" style="font-size: 14pt">
                                <span style="margin-right: 2px;" translate>School</span> ({{schoolAnnouncements.length}}
                                )
                            </mat-panel-title>
                            <mat-panel-description>
                                <!--No Description-->
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <!--Expand Content-->
                        <div style="margin-bottom: 10px;padding: 0 24px !important;"
                            *ngFor="let sa of schoolAnnouncements">
                            <div class="robotoMedium" style="font-size: 11pt;">
                                <span class="newBadge robotoMedium" style="font-size: 11pt;"
                                    *ngIf="sa.IsNewSinceLastLogin == 1" translate>NEW</span><span
                                *ngIf="sa.IsNewSinceLastLogin == 1" class="robotoMedium"
                                style="font-size: 11pt;"> - </span> <span class="robotoMedium"
                                style="font-size: 11pt;"> {{sa.StartDate | date: 'MM/dd/yy'}} - </span><span
                                class="robotoMedium" style="font-size: 11pt;">{{sa.Title}}</span>
                            </div>
                            <div>
                                <div #textArea class="announcementText"
                                    style="margin-right: 35px;-webkit-box-orient: vertical;"
                                    [innerHTML]="sa.Announcement | safeHtml" ExternalLink></div>
                                <span *ngIf="sa.Overflow"><a
                                    style="display: flex;justify-content: flex-end;position: relative;top: -18px;"
                                    (click)="moreClick(sa)" translate>More</a></span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <mat-accordion *ngIf="classAnnouncements.length > 0" style="margin: 0px;">
                    <mat-expansion-panel class="mat-elevation-z0 bottomBorder" [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="robotoMedium" style="font-size: 14pt" translate>
                                <span style="margin-right: 2px;" translate>Class</span> ({{classAnnouncements.length}})
                            </mat-panel-title>
                            <mat-panel-description>
                                <!--No Description-->
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <!--Expand Content-->
                        <div style="margin-bottom: 10px;padding: 0 24px!important;"
                            *ngFor="let ca of classAnnouncements">
                            <div class="robotoMedium" style="font-size: 11pt;">
                                <span class="newBadge robotoMedium" style="font-size: 11pt;"
                                    *ngIf="ca.IsNewSinceLastLogin == 1" translate>NEW</span><span
                                *ngIf="ca.IsNewSinceLastLogin == 1" class="robotoMedium"
                                style="font-size: 11pt;"> - </span> <span class="robotoMedium"
                                style="font-size: 11pt;"> {{ca.StartDate | date: 'MM/dd/yy'}} - </span><span
                                class="robotoMedium" style="font-size: 11pt;">{{ca.Title}}</span>
                            </div>
                            <div>
                                <div #textArea class="announcementText"
                                    style="margin-right: 35px;-webkit-box-orient: vertical;"
                                    [innerHTML]="ca.Announcement | safeHtml" ExternalLink></div>
                                <span *ngIf="ca.Overflow"><a
                                    style="display: flex;justify-content: flex-end;position: relative;top: -18px;"
                                    (click)="moreClick(ca)" translate>More</a></span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <div *ngIf="card.disabled" class="robotoMedium"
            style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
            <div style="padding: 50px;">
                {{card.disabledMessage}}
            </div>
        </div>
    </div>
</mat-card>
